<p class="title">
  Disbursement
  <mat-icon class="titleIcon">chevron_right</mat-icon> Disbursement Tracker
</p>

<!-- Compact Overall Progress Header -->
<div class="progress-summary-card">
  <div class="summary-header">
    <div class="header-title">
      <mat-icon class="header-icon">analytics</mat-icon>
      <h5>Overall PDA & FDA Progress</h5>
    </div>
  </div>

  <!-- SKELETON LOADER FOR PROGRESS TILES -->
  <div class="progress-card-grid" *ngIf="isLoading">
    <div class="progress-tile skeleton-tile" *ngFor="let item of [1,2,3,4,5]">
      <div class="skeleton-line short"></div>
      <div class="skeleton-bar"></div>
      <div class="skeleton-line tiny"></div>
    </div>
  </div>

  <!-- ACTUAL PROGRESS TILES -->
  <div class="progress-card-grid" *ngIf="!isLoading">
    <!-- PDA Completed -->
    <div class="progress-tile">
      <div class="tile-top">
        <span class="tile-label">PDA Completed</span>
        <span class="tile-badge pda-badge">
          {{ overallProgress.pdaCompleted.total ? Math.round((overallProgress.pdaCompleted.value / overallProgress.pdaCompleted.total) * 100) : 0 }}%
        </span>
      </div>
      <div class="mini-progress-track">
        <div
          class="mini-progress-fill pda-completed"
          [style.width.%]="(overallProgress.pdaCompleted.value / (overallProgress.pdaCompleted.total || 1)) * 100"
        ></div>
      </div>
      <div class="tile-bottom">
        <strong>{{ overallProgress.pdaCompleted.value }}</strong>
        <small>/ {{ overallProgress.pdaCompleted.total }}</small>
      </div>
    </div>

    <!-- PDA Under Process -->
    <div class="progress-tile">
      <div class="tile-top">
        <span class="tile-label">PDA In Process</span>
        <span class="tile-badge pda-process-badge">
          {{ overallProgress.pdaUnderProcess.total ? Math.round((overallProgress.pdaUnderProcess.value / overallProgress.pdaUnderProcess.total) * 100) : 0 }}%
        </span>
      </div>
      <div class="mini-progress-track">
        <div
          class="mini-progress-fill pda-process"
          [style.width.%]="(overallProgress.pdaUnderProcess.value / (overallProgress.pdaUnderProcess.total || 1)) * 100"
        ></div>
      </div>
      <div class="tile-bottom">
        <strong>{{ overallProgress.pdaUnderProcess.value }}</strong>
        <small>/ {{ overallProgress.pdaUnderProcess.total }}</small>
      </div>
    </div>

    <!-- FDA Completed -->
    <div class="progress-tile">
      <div class="tile-top">
        <span class="tile-label">FDA Completed</span>
        <span class="tile-badge fda-badge">
          {{ overallProgress.fdaCompleted.total ? Math.round((overallProgress.fdaCompleted.value / overallProgress.fdaCompleted.total) * 100) : 0 }}%
        </span>
      </div>
      <div class="mini-progress-track">
        <div
          class="mini-progress-fill fda-completed"
          [style.width.%]="(overallProgress.fdaCompleted.value / (overallProgress.fdaCompleted.total || 1)) * 100"
        ></div>
      </div>
      <div class="tile-bottom">
        <strong>{{ overallProgress.fdaCompleted.value }}</strong>
        <small>/ {{ overallProgress.fdaCompleted.total }}</small>
      </div>
    </div>

    <!-- FDA Under Process -->
    <div class="progress-tile">
      <div class="tile-top">
        <span class="tile-label">FDA In Process</span>
        <span class="tile-badge fda-process-badge">
          {{ overallProgress.fdaUnderProcess.total ? Math.round((overallProgress.fdaUnderProcess.value / overallProgress.fdaUnderProcess.total) * 100) : 0 }}%
        </span>
      </div>
      <div class="mini-progress-track">
        <div
          class="mini-progress-fill fda-process"
          [style.width.%]="(overallProgress.fdaUnderProcess.value / (overallProgress.fdaUnderProcess.total || 1)) * 100"
        ></div>
      </div>
      <div class="tile-bottom">
        <strong>{{ overallProgress.fdaUnderProcess.value }}</strong>
        <small>/ {{ overallProgress.fdaUnderProcess.total }}</small>
      </div>
    </div>

    <!-- FDA Yet To Receive (>30 days) -->
    <div class="progress-tile alert-tile">
      <div class="tile-top">
        <span class="tile-label">FDA Overdue (>30d)</span>
        <span class="tile-badge alert-badge">Overdue</span>
      </div>
      <div class="mini-progress-track">
        <div
          class="mini-progress-fill fda-receive"
          [style.width.%]="(overallProgress.fdaYetToReceive.value / (overallProgress.pdaCompleted.value || 1)) * 100"
        ></div>
      </div>
      <div class="tile-bottom">
        <strong class="alert-text">{{ overallProgress.fdaYetToReceive.value }}</strong>
        <small>/ {{ overallProgress.pdaCompleted.value }}</small>
      </div>
    </div>
  </div>
</div>

<div style="overflow-x: hidden" class="theme-dark">
  <div class="topbar topbar-margin">
    <div class="search-section" style="margin-left: 10px">
      <mat-form-field
        class="search-bar"
        appearance="outline"
        style="margin-bottom: 0px"
      >
        <input
          type="text"
          matInput
          placeholder="Search disbursement..."
          [(ngModel)]="searchTerm"
          (input)="onSearchInput($event)"
          (focus)="onSearchFocus()"
          [matAutocomplete]="autoSearch"
        />

        <!-- Clear (X) Button -->
        <button
          *ngIf="searchTerm"
          mat-icon-button
          matSuffix
          aria-label="Clear search"
          (click)="clearSearchInput($event)"
          style="width: 24px; height: 24px; line-height: 24px"
        >
          <mat-icon style="font-size: 18px; color: #ffffff">close</mat-icon>
        </button>

        <!-- Search Icon -->
        <mat-icon matSuffix *ngIf="!searchTerm" style="color: #ffffff">search</mat-icon>

        <!-- Autocomplete Panel -->
        <mat-autocomplete
          #autoSearch="matAutocomplete"
          (optionSelected)="onSuggestionSelected($event)"
        >
          <mat-option *ngFor="let option of searchSuggestions" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div>
      <button
        mat-raised-button
        color="primary"
        class="add-button button-margin"
        (click)="navigateToPda()"
        *ngIf="roleId !== 3"
      >
        Add PDA
      </button>
      <button
        mat-raised-button
        color="primary"
        class="add-button button-margin"
        (click)="navigateToFda()"
        *ngIf="roleId !== 3"
      >
        Add FDA
      </button>
      <button
        mat-raised-button
        color="primary"
        class="add-button button-margin"
        *ngIf="roleId !== 3"
        (click)="openColumnDialog()"
      >
        <mat-icon fontSet="material-symbols-outlined">insert_drive_file</mat-icon>
        Export
      </button>
      <button
        mat-icon-button
        class="filter-top-btn"
        (click)="openFilterDialog()"
        *ngIf="roleId !== 3"
        matTooltip="Table Filters"
      >
        <mat-icon>filter_list</mat-icon>
      </button>
    </div>
  </div>

 <div style="overflow-x: auto; position: relative">
    <div class="table-container">
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        multiTemplateDataRows
        class="mat-elevation-z8 disbursement-table"
        style="overflow: visible"
        [ngClass]="{ 'dark-table': isDarkMode() }"
      >
        <!-- Skeleton Column Definition (Spans full width) -->
        <ng-container matColumnDef="skeleton">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="columnsToDisplayOnly.length"
            style="padding: 10px 16px; border-bottom: 1px solid var(--color-bg-dark-2);"
          >
            <div class="skeleton-cell-row"></div>
          </td>
        </ng-container>

        <!-- Dynamic Columns -->
        <ng-container *ngFor="let column of columnsToDisplay">
          <ng-container
            [matColumnDef]="column.property"
            [sticky]="
              column.property === 'eye_icon' ||
              column.property === 'disbursement_id'
            "
          >
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [disabled]="
                column.property === 'eye_icon' ||
                column.property === 'action' ||
                column.property === 'edit'
              "
              [ngStyle]="
                column.property === 'eye_icon'
                  ? { width: '35px', padding: '0', 'border-right': 'none' }
                  : column.property === 'disbursement_id'
                    ? { 'min-width': '130px' }
                    : {}
              "
            >
              {{ column.name }}
            </th>

            <ng-container *ngIf="column.property === 'edit'">
              <td mat-cell *matCellDef="let element" style="text-align: center; padding: 4px">
                <mat-icon
                  *ngIf="isEditAllowed(element)"
                  matTooltip="Edit Request"
                  class="edit-icon enabled"
                  (click)="onEdit(element, $event)"
                >
                  edit
                </mat-icon>
                <mat-icon
                  *ngIf="!isEditAllowed(element)"
                  matTooltip="Editing disabled (PDA or FDA is completed)"
                  class="edit-icon disabled"
                  (click)="$event.stopPropagation()"
                >
                  edit_off
                </mat-icon>
              </td>
            </ng-container>

            <ng-container *ngIf="column.property === 'total_savings'">
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: center"
                (click)="toggle(element); $event.stopPropagation()"
              >
                <span
                  [matTooltip]="'PDA Savings: ' + formatAmount(element.pda_savings) + ' | FDA Savings: ' + formatAmount(element.fda_savings)"
                  matTooltipPosition="above"
                  style="cursor: help; text-decoration: underline dotted;"
                >
                  {{ formatAmount(element[column.property]) }}
                </span>
              </td>
            </ng-container>

            <ng-container *ngIf="column.property === 'eye_icon'">
              <td
                mat-cell
                *matCellDef="let element"
                style="width: 35px; padding: 0 0 0 10px; border-right: none; z-index: 10;"
                (click)="toggle(element); $event.stopPropagation()"
              >
                <mat-icon
                  fontSet="material-symbols-outlined"
                  class="file-preview-icon"
                  title="View Uploaded Files"
                  (click)="showFilePreview(element, $event); $event.stopPropagation()"
                >
                  visibility
                </mat-icon>
              </td>
            </ng-container>

            <ng-container *ngIf="column.property === 'disbursement_id'">
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: left; padding-left: 0; border-left: none; z-index: 9;"
                [attr.style]="
                  (element.due_color ? 'background-color: ' + element.due_color + ' !important;' : '') +
                  (element.due_color ? ' color: #000000 !important;' : '!ffffff !important;')
                "
                (click)="toggle(element); $event.stopPropagation()"
              >
                <div style="display: flex; align-items: center; justify-content: flex-start; gap: 8px;">
                  <div style="width: 20px; height: 20px; display: inline-flex; justify-content: center; align-items: center;">
                    <mat-icon
                      *ngIf="element.due_comment && element.due_comment !== 'NA'"
                      class="due-info-icon"
                      (mouseenter)="showTooltip(element, $event)"
                      (mouseleave)="hideTooltip()"
                      style="font-size: 20px; width: 20px; height: 20px; cursor: help;"
                    >
                      info
                    </mat-icon>
                  </div>
                  <span style="white-space: nowrap; font-weight: bold">{{ element[column.property] }}</span>
                </div>
              </td>
            </ng-container>

            <ng-container *ngIf="column.property === 'loss_prevented_reason'">
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: center; padding: 8px"
                (click)="toggle(element); $event.stopPropagation()"
              >
                <span
                  class="savings-reason-cell"
                  [appTruncateTooltip]="element[column.property]"
                  [ariaLabel]="'Savings Reason: ' + element[column.property]"
                  (showCustomTooltip)="tooltipData = $event"
                  (hideCustomTooltip)="tooltipData = null"
                >
                  {{ element[column.property] }}
                </span>
              </td>
            </ng-container>

            <ng-container
              *ngIf="
                column.property != 'pda_status' &&
                column.property != 'fda_status' &&
                column.property != 'final_status' &&
                column.property != 'action' &&
                column.property != 'files' &&
                column.property != 'edit'
              "
            >
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: center"
                (click)="toggle(element); $event.stopPropagation()"
              >
                <ng-container
                  *ngIf="
                    roleId === 3 &&
                      (column.property === 'advance_amount_remitted' ||
                        column.property === 'outstanding_balance' ||
                        column.property === 'remark');
                    else normalCell
                  "
                >
                  <ng-container *ngIf="column.property === 'remark'; else textInputField">
                    <ng-container *ngIf="isEditing(element, 'remark'); else remarkDisplay">
                      <div class="remark-autocomplete" (click)="$event.stopPropagation()">
                        <input
                          type="text"
                          class="cell-edit-input"
                          [value]="editValue"
                          (input)="editValue = $any($event.target).value"
                          (click)="$event.stopPropagation()"
                          (keydown.enter)="saveCellValue(element, 'remark', $event)"
                          (keydown.escape)="editingCell = null"
                          placeholder="Enter remark"
                          autofocus
                        />
                      </div>
                    </ng-container>
                    <ng-template #remarkDisplay>
                      <span class="editable-cell" (click)="startEditing(element, 'remark', $event)">
                        {{ element.remark || "-" }}
                      </span>
                    </ng-template>
                  </ng-container>

                  <ng-template #textInputField>
                    <input
                      *ngIf="isEditing(element, column.property); else displayValue"
                      type="text"
                      class="cell-edit-input"
                      [value]="editValue"
                      (click)="$event.stopPropagation()"
                      (keydown.enter)="saveCellValue(element, column.property, $event)"
                      (keydown.escape)="editingCell = null"
                      autofocus
                    />
                    <ng-template #displayValue>
                      <span class="editable-cell" (click)="startEditing(element, column.property, $event)">
                        {{ isAmountColumn(column.property) ? formatAmount(element[column.property]) : element[column.property] || "-" }}
                      </span>
                    </ng-template>
                  </ng-template>
                </ng-container>

                <ng-template #normalCell>
                  <ng-container *ngIf="isAmountColumn(column.property); else normalValue">
                    {{ formatAmount(element[column.property]) }}
                  </ng-container>
                  <ng-template #normalValue>
                    {{ element[column.property] }}
                  </ng-template>
                </ng-template>
              </td>
            </ng-container>

            <ng-container *ngIf="column.property === 'action'">
              <td mat-cell *matCellDef="let element" style="text-align: center; padding: 4px">
                <div style="display: flex; gap: 8px; justify-content: center" *ngIf="subusername !== 'demo'">
                  <div style="min-width: 24px; display: flex; align-items: center; justify-content: center">
                    <mat-icon
                      matTooltip="InActivate"
                      *ngIf="element.status === 'PDA Completed' && element.pda_state !== 'N'"
                      (click)="onDelete(element, 'inactive'); $event.stopPropagation()"
                      style="color: #ffa375; cursor: pointer"
                    >
                      highlight_off
                    </mat-icon>
                    <mat-icon
                      *ngIf="element.pda_state === 'N'"
                      matTooltip="InActivated"
                      fontSet="material-symbols-outlined"
                      style="color: #202223"
                    >
                      do_not_disturb_on
                    </mat-icon>
                  </div>
                  <div style="min-width: 24px; display: flex; align-items: center; justify-content: center" *ngIf="roleId === 1">
                    <mat-icon
                      matTooltip="Delete"
                      (click)="onDelete(element, 'delete'); $event.stopPropagation()"
                      style="color: red; cursor: pointer"
                    >
                      delete
                    </mat-icon>
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container
              *ngIf="
                column.property == 'pda_status' ||
                column.property == 'fda_status' ||
                column.property == 'final_status' ||
                column.property == 'files'
              "
            >
              <td
                mat-cell
                *matCellDef="let element"
                style="text-align: center"
                (click)="toggle(element); $event.stopPropagation()"
              >
                <span
                  class="statusColumn"
                  [attr.style]="
                    'background: ' +
                    (column.property === 'pda_status'
                      ? element.pda_status_background_color
                      : column.property === 'fda_status'
                        ? element.fda_status_background_color
                        : column.property === 'final_status'
                          ? element.final_status_background_color
                          : element.status_background_color) +
                    '!important;' +
                    'color: ' +
                    (column.property === 'pda_status'
                      ? element.pda_status_text_color
                      : column.property === 'fda_status'
                        ? element.fda_status_text_color
                        : column.property === 'final_status'
                          ? element.final_status_text_color
                          : element.status_text_color) +
                    ' !important;'
                  "
                >
                  {{ element[column.property] === 'NA' ? 'N/A' : element[column.property] }}
                </span>
              </td>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="columnsToDisplayOnly.length"
            class="expanded-content-cell"
          >
            <div
              class="example-element-detail-wrapper"
              [class.example-element-detail-wrapper-expanded]="isExpanded(element)"
            >
              <div class="example-element-detail">
                <div class="expanded-wrapper">
                  <app-disburs-dtls-comp
                    *ngIf="isExpanded(element)"
                    [disbursement_obj]="element"
                    (viewLess)="viewLess()"
                    (disbursementChange)="handleDisbursementChange($event)"
                  >
                  </app-disburs-dtls-comp>
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Header Row -->
        <tr mat-header-row *matHeaderRowDef="columnsToDisplayOnly; sticky: true"></tr>

        <!-- SKELETON LOADER ROWS (Rendered when isLoading = true) -->
        <tr
          mat-row
          *matRowDef="let row; columns: ['skeleton']"
          [style.display]="isLoading ? 'table-row' : 'none'"
        ></tr>

        <!-- ACTUAL DATA ROWS (Rendered when isLoading = false) -->
        <tr
          mat-row
          *matRowDef="let element; columns: columnsToDisplayOnly; let i = dataIndex"
          [style.display]="isLoading ? 'none' : 'table-row'"
          [ngStyle]="{
            'font-weight': isExpanded(element) ? '600' : 'inherit',
            cursor: roleId === 3 ? 'default' : 'pointer'
          }"
          class="example-element-row"
          [class.zebra-even-row]="i % 2 === 0"
          [class.zebra-odd-row]="i % 2 !== 0"
          [class.example-expanded-row]="isExpanded(element)"
        ></tr>

        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>

      <!-- NO DATA TEXT -->
      <div *ngIf="!isLoading && dataSource.data.length === 0" class="no-data-text">
        No disbursement found.
      </div>
    </div>
  </div>

  <div class="pagination-row">
    <mat-paginator
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50, 100]"
      [pageIndex]="currentPage - 1"
      (page)="onPageChange($event)"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
    <ng-template #noData>
    <div class="no-data-text">No disbursement found.</div>
  </ng-template>
</div>